import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetCompanyInfo = (domain: string) => {
    return useQuery({
        queryKey: aiAgentQueryKeys.companyInfo(domain),
        queryFn: async ({ signal }) => {
            return await salesApiService.aiAgent.meeting.getCompanyInfo({ domain }, { cancellation: signal });
        },
        enabled: !!domain,
        placeholderData: keepPreviousData,
    });
};
